<template>
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.5 7.5L28.5 28.5M7.5 28.5L28.5 7.5" stroke="#777777" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
    export default {
        name: "CloseIcon"
    }
</script>

<style scoped>

</style>